export const COLUMN_KEYS = {
  request_date: 'request_date',
  claim_id_display: 'claim_id_display',
  requesting_user: 'requesting_user',
  financial_status_last_update: 'financial_status_last_update',
  exposure_label: 'exposure_label',
  payable_with_reserve_type: 'payable_with_reserve_type',
  request_status: 'request_status',
  financial_status: 'financial_status',
  amount: 'amount',
  actions: 'actions',
  select_finance: 'select_finance',
  select_row_button: 'select_row_button',
  service_start_date: 'service_start_date',
  service_end_date: 'service_end_date',
  payment_period: 'payment_period',
  payees: 'payees_main_table',
} as const;

export const EXTENDABLE_COLUMN_KEYS = {
  sub_reserves: 'sub_reserves',
  issued_by: 'issued_by',
  payment_type: 'payment_type_desc',
  payees: 'payees',
  sent_to: 'sent_to',
  reference: 'reference',
  note: 'note',
  deductible_applied: 'deductible_applied',
  payment_method: 'payment_method',
  fund_account_number: 'fund_account_number',
  base_amount: 'base_amount',
  conversion_date: 'conversion_date',
  conversion_rate: 'conversion_rate',
  vat_details: 'vat_details',
} as const;

/*
 * Type utility to ensure no overlap between the values of COLUMN_KEYS and EXTENDABLE_COLUMN_KEYS objects
 * (this does not prevent duplicate values within each object)
 */
type ExpectNever<T extends never> = T;
type ColumnValues = (typeof COLUMN_KEYS)[keyof typeof COLUMN_KEYS];
type ExtendableColumnValues = (typeof EXTENDABLE_COLUMN_KEYS)[keyof typeof EXTENDABLE_COLUMN_KEYS];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type hoverToViewOverlappingValues = ExpectNever<ColumnValues & ExtendableColumnValues>;
